import { createRouter, createWebHistory } from 'vue-router';
import { useConfigStore } from '../stores/config';

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('../views/Home.vue'),
    meta: { layout: 'public', titleKey: 'nav.home' },
  },
  {
    path: '/pricing',
    name: 'Pricing',
    component: () => import('../views/Pricing.vue'),
    meta: { layout: 'public', titleKey: 'nav.pricing' },
  },
  {
    path: '/docs',
    name: 'Docs',
    component: () => import('../views/Docs.vue'),
    meta: { layout: 'public', titleKey: 'nav.docs' },
  },
  {
    path: '/geo',
    name: 'Geo',
    component: () => import('../views/Geo.vue'),
    meta: { layout: 'public', titleKey: 'nav.geo' },
  },
  {
    path: '/member',
    name: 'Member',
    component: () => import('../views/Member.vue'),
    meta: { layout: 'public', titleKey: 'nav.member' },
  },
  {
    path: '/console',
    name: 'Dashboard',
    component: () => import('../views/Dashboard.vue'),
    alias: ['/dashboard'],
    meta: { layout: 'console', requiresAuth: true, titleKey: 'console.dashboard' },
  },
  {
    path: '/console/config',
    name: 'Config',
    component: () => import('../views/Config.vue'),
    alias: ['/config'],
    meta: { layout: 'console', requiresAuth: false, titleKey: 'console.config' },
  },
  {
    path: '/console/dns',
    name: 'DNS',
    component: () => import('../views/DNS.vue'),
    alias: ['/dns'],
    meta: { layout: 'console', requiresAuth: true, titleKey: 'console.dns' },
  },
  {
    path: '/console/dns-batch',
    name: 'DNSBatch',
    component: () => import('../views/DNSBatch.vue'),
    alias: ['/dns-batch'],
    meta: { layout: 'console', requiresAuth: true, titleKey: 'console.dnsBatch' },
  },
  {
    path: '/console/ssl',
    name: 'SSL',
    component: () => import('../views/SSL.vue'),
    alias: ['/ssl'],
    meta: { layout: 'console', requiresAuth: true, titleKey: 'console.ssl' },
  },
  {
    path: '/console/ssl-batch',
    name: 'SSLBatch',
    component: () => import('../views/SSLBatch.vue'),
    alias: ['/ssl-batch'],
    meta: { layout: 'console', requiresAuth: true, titleKey: 'console.sslBatch' },
  },
  {
    path: '/console/security',
    name: 'Security',
    component: () => import('../views/Security.vue'),
    alias: ['/security'],
    meta: { layout: 'console', requiresAuth: true, titleKey: 'console.security' },
  },
  {
    path: '/console/rules',
    name: 'RuleManager',
    component: () => import('../views/RuleManager.vue'),
    alias: ['/rules'],
    meta: { layout: 'console', requiresAuth: true, titleKey: 'console.rules' },
  },
  {
    path: '/console/www-redirect',
    name: 'WwwRedirect',
    component: () => import('../views/WwwRedirect.vue'),
    alias: ['/www-redirect'],
    meta: { layout: 'console', requiresAuth: true, titleKey: 'console.wwwRedirect' },
  },
  {
    path: '/console/domain-batch',
    name: 'DomainBatch',
    component: () => import('../views/DomainBatch.vue'),
    alias: ['/domain-batch'],
    meta: { layout: 'console', requiresAuth: true, titleKey: 'console.domainBatch' },
  },
  {
    path: '/console/workers-batch',
    name: 'WorkersBatch',
    component: () => import('../views/WorkersBatch.vue'),
    alias: ['/workers-batch'],
    meta: { layout: 'console', requiresAuth: true, titleKey: 'console.workersBatch' },
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

// 路由守卫：检查是否已配置
router.beforeEach((to, from, next) => {
  const configStore = useConfigStore();

  // 如果需要认证但未配置，重定向到配置页面
  if (to.meta.requiresAuth && !configStore.hasValidConfig) {
    next({ name: 'Config', query: { redirect: to.fullPath } });
  } else {
    next();
  }
});

export default router;
